import { CooperativeFormLayout } from 'presentation/doctor/components/Forms/CooperativeForm'
import React from 'react'

export const CooperativeForm = () => <CooperativeFormLayout />

export default CooperativeForm
